import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { bindActionCreators } from "redux";
import Nav from "../../components/Nav";
// import StripeCheckoutButton from "../../components/StripeCheckoutButton";
import AnchorLink from "react-anchor-link-smooth-scroll";
import fetch from "isomorphic-fetch";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      total: null,
      target: 1200,
    };
  }

  componentDidMount() {
    const url = `https://56p3tmgi4d.execute-api.eu-west-1.amazonaws.com/dev/total`;

    fetch(url, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response.count[0].total);
        this.setState({ total: response.count[0].total });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    let spotlights = [
      {
        title: "£100 Cash Prize",
        intro:
          "The main prize - £100 cash to spend as you wish, provided by Upton Priory PTFA.",
        img: "/static/media/100.jpeg",
        winners: [],
      },
      {
        title: "£50 Cash Prize",
        intro: "£50 cash to spend as you wish, provided by Upton Priory PTFA.",
        img: "/static/media/50.jpeg",
        winners: [],
      },
      {
        title: "£10 Cash Prize x 5",
        intro:
          "5x £10 cash prizes to spend as you wish, provided by Upton Priory PTFA.",
        img: "/static/media/10.jpeg",
        winners: [],
      },
      {
        title: "Bowling Party for 4!",
        intro:
          '2 games of bowling for a maximum of 4 people, and 1 round of drinks <a target="_blank" href="https://wynwoodlanes.co.uk//">Wynwood Lanes, Manchester</a>.',
        img: "/static/media/wynwood.jpeg",
        winners: [],
      },
      {
        title: "Axe Throwing",
        intro:
          'An hour long axe throwing session for two people (age 13+ only) at <a target="_blank" href="https://thevikingaxe.co.uk/">The Viking Axe, Macclesfield</a>.',
        img: "/static/media/axe.jpg",
        winners: [],
      },
      {
        title: "Yoga Session",
        intro:
          'Deep Rest Yoga Session provide by <a target="_blank" href="https://www.wiseheartsam.com/">Wise Heart Sam</a>.',
        img: "/static/media/yoga.jpeg",
        winners: [],
      },
      {
        title: "£25 One4All Voucher",
        intro:
          '£25 One4All voucher donated by Zenka. Usable at over 40 high street retailers including Argos, Boots, Debenhams, M&S and many more. <a target="_blank" href="https://www.one4all.com/uk/">More Info</a>.',
        img: "/static/media/one4all-logo.jpg",
        winners: [],
      },
      {
        title: "Toys and Puzzles",
        intro:
          'Selection of toys and puzzles kindly donated by <a target="_blank" href="https://www.thetoyshop.com/">The Entertainer</a>.',
        img: "/static/media/games.jpeg",
        winners: [],
      },
      {
        title: "Gails Bakery Treats",
        intro:
          'A selection of treats from <a target="_blank" href="https://gailsbread.co.uk/">Gails Bakery</a>.',
        img: "/static/media/gails.jpeg",
        winners: [],
      },
      {
        title: "Gifts from Tesco",
        intro:
          'A selection of gifts including a Disney book and a Nivea Men gift set from <a target="_blank" href="https://www.tesco.com/">Tesco</a>.',
        img: "/static/media/tesco.jpeg",
        winners: [],
      },
    ];

    return (
      <div>
        <Helmet>
          <title>Upton Priory School - PTFA Christmas Competition</title>
          <meta
            name="description"
            content="PTFA Christmas Competition. £1 per entry. Answer a simple question to win £100 and much more!"
          />

          <meta property="og:url" content="https://uptonprioryraffle.com" />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="Upton Priory School - PTFA Christmas Competition"
          />
          <meta
            property="og:description"
            content="PTFA Christmas Competition. £1 per entry. Answer a simple question to win £100 and much more!"
          />
          <meta
            property="og:image"
            content="https://uptonprioryraffle.com/static/media/upton.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta property="twitter:domain" content="uptonprioryraffle.com" />
          <meta
            property="twitter:url"
            content="https://uptonprioryraffle.com"
          />
          <meta
            name="twitter:title"
            content="Upton Priory School - PTFA Christmas Competition"
          />
          <meta
            name="twitter:description"
            content="PTFA Christmas Competition. £1 per entry. Answer a simple question to win £100 and much more!"
          />
          <meta
            name="twitter:image"
            content="https://uptonprioryraffle.com/static/media/upton.png"
          />
        </Helmet>
        <div className="container mx-auto pt-8 pb-8">
          <Nav />
        </div>

        <div className="bg-upton-100 pt-8 pb-8">
          <div className="flex-1 flex flex-col items-center justify-center container mx-auto pl-6 pr-6 lg:pl-0 lg:pr-0">
            <h1 className="text-white text-center text-4xl lg:text-6xl uppercase font-black">
              Christmas <span className="font-normal">Competition</span>
            </h1>
            {/*
            <p className="w-full text-white text-center text-xl lg:text-2xl font-thin mt-6">
              The competition has now closed. Thank you for entering, we sold
              £1,137 of entries!
            </p>
            <p className="w-full text-white text-center text-xl lg:text-2xl font-thin mt-6">
              Winners will be emailed over the next week, but you can check your
              numbers below.
            </p> */}
            <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
              From cash prizes and shopping vouchers to exciting experiences
              like bowling, axe throwing, and yoga, plus festive treats and gift
              sets—you’re sure to find something you love! Browse the prize
              gallery below and click the links for more details on these
              fantastic rewards.
              <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
                Tickets are just £1 each, and you can buy as many as you like
                online. Spread the word—everyone can enter!
              </p>
              <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
                The prize draw will take place on Friday 12th December, and
                winners will be notified by email.
              </p>
            </p>
            <p className="w-full text-white text-left text-xl lg:text-2xl font-thin mt-6 ">
              Good luck!
            </p>

            <AnchorLink
              className="disabled text-white text-xl lg:text-2xl font-bold uppercase bg-orange-700 hover:bg-orange-500 p-4 inline-block mt-8 mb-8"
              href="#buy-tickets"
            >
              Enter Competition
            </AnchorLink>
            <>
              {!!this.state.total && (
                <div className="w-full mt-4">
                  <p className="text-center w-full text-white text-xl lg:text-2xl font-thin mt-6 mb-0">
                    So far we have raised £{this.state.total} of our £
                    {this.state.target} target.
                  </p>
                  <div className="meter red">
                    <span
                      style={{
                        width:
                          Math.round(
                            (this.state.total / this.state.target) * 100
                          ) + "%",
                      }}
                    />
                  </div>
                </div>
              )}
            </>
          </div>
        </div>

        <div className="w-100 flex flex-col justify-center bg-gradient-to-b to-black from-gray-1400 relative pt-12 pb-12">
          <div className="container flex flex-row flex-wrap mx-auto z-10">
            {spotlights.map((s, i) => (
              <div className={`w-full lg:w-1/3 text-white p-4  text-center`}>
                <img
                  className="w-full h-48 rounded-lg rounded-b-none object-cover mx-auto"
                  src={s.img}
                />

                <div className="bg-gray-1300 rounded-lg  rounded-t-none p-6 pb-6 pt-6 text-center">
                  <h2 className="text-white text-2xl font-black uppercase">
                    <span className="font-normal">{s.title}</span>
                  </h2>
                  <div className="text-white mt-5 font-light text-sm h-20 intro">
                    <span dangerouslySetInnerHTML={{ __html: s.intro }} />
                  </div>
                  {/* <p className="text-white mt-5 font-light text-sm h-12 intro">
                    Winning number: {s.winners.map((w) => w + "  ")}
                  </p> */}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div
          id="buy-tickets"
          className="container mx-auto pt-12 pb-12 pl-4 pr-4"
        >
          {/* <StripeCheckoutButton /> */}
          Tickets not available at this time.
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ data }) => ({
  data,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
